import { amountToLong } from '../../../../../utils/amount';
import { toUnixTimestamp } from './dateTime';
import { BoletoDetails } from '../../../../../types/Boleto';

export type BoletoBiLoggerInputParams = Pick<
  BoletoDetails,
  'amount' | 'expireDate' | 'chargeId' | 'orderId'
>;

export interface BoletoBiLoggerParams {
  amountLong: number;
  due_date: number;
  transactionid: string;
  orderSnapshotId: string;
}

export function convertToBiLoggerParams(
  params: BoletoBiLoggerInputParams
): BoletoBiLoggerParams {
  const amountLong = amountToLong(params.amount);
  const due_date = toUnixTimestamp(params.expireDate);

  return {
    amountLong,
    due_date,
    transactionid: params.chargeId,
    orderSnapshotId: params.orderId,
  };
}
